import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { User } from 'src/app/data/model/user';
import { UserPortalGroup } from 'src/app/data/model/user-portal-group';
import { EnvironmentConfig, ENV_CONFIG } from '../enviroment-config';
import { BaseService } from './abstract/base.service';
import { PagedResponseList } from './abstract/read-api.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService extends BaseService {
  constructor(
    protected http: HttpClient,
    @Inject(ENV_CONFIG) config: EnvironmentConfig
  ) {
    super(config);
  }

  otp_login(data: { username: string; otp_code: string }) {
    const path = this.getPath('portal/auth/otp-login');

    return this.http.post<{ key: string }>(path, data, {
      headers: this.createHeaders(),
    });
  }

  login(data: { username: string; password: string }) {
    const path = this.getPath('rest-auth/login/');

    return this.http.post<{ key: string }>(path, data, {
      headers: this.createHeaders(),
    });
  }

  getGroups(user_id: string) {
    const path = this.getPath(`portal/auth/user-portal-group?user=${user_id}`);

    return this.http.get<PagedResponseList<UserPortalGroup>>(path, {
      headers: this.createHeaders(),
    });
  }

  getUser() {
    const path = this.getPath('portal/auth/get-user');//('rest-auth/user/');

    return this.http.get<User>(path, {
      headers: this.createHeaders(),
    });
  }

  logOut() {
    const path = this.getPath('rest-auth/logout/');

    return this.http.post(path, {
      headers: this.createHeaders(),
    });
  }
}
